<template>
  <v-row class="mt-2">
    <v-col>
      <v-sheet rounded color="#ECEFF1" >
        <v-breadcrumbs :items="breadcrumbData">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :disabled="item.disabled">
              <router-link v-if="!item.disabled" :to="item.to" style="text-decoration: none; color: inherit;">
                {{ item.text }}
              </router-link>
              <span v-else :style="{ color: '#868585' }">{{ item.text }}</span>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-sheet>

    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "breadCrumb",
  props: ['breadcrumbData'],

}
</script>

<style scoped>

</style>